import type { GridProps } from "@mui/material";
import { Grid } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  gridProps?: GridProps;
}

const ScrollableColumns = ({ gridProps = {}, children }: PropsWithChildren<Props>) => (
  <Grid
    container
    {...gridProps}
    sx={[{ height: "100%", overflow: "hidden" }, ...(Array.isArray(gridProps.sx) ? gridProps.sx : [gridProps.sx])]}
  >
    {children}
  </Grid>
);

export default ScrollableColumns;
